import { render, staticRenderFns } from "./MapsList.vue?vue&type=template&id=3621b852&"
import script from "./MapsList.vue?vue&type=script&lang=js&"
export * from "./MapsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports